import { render, staticRenderFns } from "./UserProfileStatusSlider.vue?vue&type=template&id=479d4b49&scoped=true&"
import script from "./UserProfileStatusSlider.vue?vue&type=script&lang=js&"
export * from "./UserProfileStatusSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479d4b49",
  null
  
)

export default component.exports